import { useEffect, useState } from "react";
import {
  PaymentMethodAnimationConfiguration as AnimConfig,
  GlobalConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";
import AmountToWords from "../../_utils/AmountToWords";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import CommonLayout from "../../_utils/CommonLayout";
import Loader from "../../Loader/Index";
import CommonToast from "../../_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const FieldForceTransferAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  isNeft,
  setIsNeft,
  isRtgs,
  setIsRtgs,
  setIsImps,
  BenEnableNextButton,
  setShowRupeeSymbol,
  amountInWords,
  setAmountInWords,
  copyData,
  setCopyData,
  selectedValueName,
  setselectedValueName,
  NewAmount,
  setNewAmount,
  type,
  setAmountDisable,
  currentAccountDetails,
  isStepValid,
  RequestAmountWords,
  isRtgsValid,
  txnLoading,
}) => {
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [isCommentFocused, setIsCommentFocused] = useState(false);

  const computeCommentVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === GlobalConfiguration.lengthCheckZero) {
      return focused ? "typing" : "default";
    }
    if (length >= GlobalConfiguration.lengthCheckThree) return "verified";
    return focused ? "typing" : "error";
  };

  useEffect(() => {
    if (txnPayLoad?.amount && !amountInWords) {
      const amountNumber = parseFloat(txnPayLoad?.amount);
      const amountWords = AmountToWords(amountNumber);
      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setAmountInWords(adjustedAmountWords);
      setTxnPayLoad((prev) => ({
        ...prev,
        amountInWords: adjustedAmountWords,
      }));
    }
  }, []);

  useEffect(() => {
    const amount = Number(txnPayLoad?.amount);
    if (!amount) return;

    const isAboveNeftLimit = amount > GlobalConfiguration?.settleTypeValue;
    const settleType = isAboveNeftLimit ? "rtgs" : "neft";
    if (txnPayLoad?.settleType === settleType && isRtgs === isAboveNeftLimit)
      return;

    setSlideAnimation(true);
    setTimeout(() => setSlideAnimation(false), AnimConfig.slideDuration);
    setIsRtgs(isAboveNeftLimit);
    setIsNeft(!isAboveNeftLimit);
    setIsImps(false);
    setTxnPayLoad((prev) => ({ ...prev, settleType }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txnPayLoad?.amount]);

  // const handleNeftClick = () => {
  //   if (Number(txnPayLoad?.amount) > GlobalConfiguration?.settleTypeValue) {
  //     CommonToast({
  //       text: (
  //         <>
  //           Transaction amount should be less than <br /> INR 2 lakhs.
  //         </>
  //       ),
  //       icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //       variant: "var(--error)",
  //     });
  //   }
  // };

  // const handleRtgsClick = () => {
  //   if (Number(txnPayLoad?.amount) <= GlobalConfiguration?.settleTypeValue) {
  //     CommonToast({
  //       text: (
  //         <>
  //           Transaction amount should be more than <br /> INR 2 lakhs.
  //         </>
  //       ),
  //       icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
  //       variant: "var(--error)",
  //     });
  //   }
  // };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };
  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      setShowRupeeSymbol(false);
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue?.replace(/[^0-9.]/g, "");
    const enteredAmount = parseFloat(
      numericValue || GlobalConfiguration?.lengthCheckZero,
    );
    const initialAmount = parseFloat(
      NewAmount || GlobalConfiguration?.lengthCheckZero,
    );

    if (type === "PayFieldForceTxn") {
      if (enteredAmount !== initialAmount) {
        setselectedValueName("customname");
      } else {
        setselectedValueName("username");
      }
    }

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));

      setShowRupeeSymbol(numericValue?.trim() !== "");
      setAmountInWords(adjustedAmountWords);
    }
  };

  const handleAutofill = () => {
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: NewAmount,
      amountInWords:
        NewAmount > GlobalConfiguration?.lengthCheckZero &&
        NewAmount <= GlobalConfiguration?.lengthCheckOne
          ? NewAmount.replace("rupees", "rupee")
          : NewAmount,
    }));
  };

  const handleRadioBtn = (event) => {
    setselectedValueName(event?.target?.value);
    if (event?.target?.value === "legalname") {
    } else if (event?.target?.value === "username") {
      handleAutofill();
    }
  };

  const handleDivBtn = (value) => {
    setselectedValueName(value);
    if (value === "legalname") {
    } else if (value === "username") {
      handleAutofill();
    }
  };

  const formattedAmount = (value) => {
    if (value === "" || value === null || value === undefined) {
      return "";
    }
    return Number(value)?.toFixed(GlobalConfiguration?.lengthCheckTwo);
  };

  const isAmountExceeding =
    type === "PayFieldForceTxn" &&
    selectedValueName === "customname" &&
    Number(txnPayLoad?.amount) > Number(NewAmount);

  return (
    <>
      {txnLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : (
        <div
          className="w-width-full px-padding-md Qlg:px-padding-base overflow-y-auto Qsmd:pt-padding-lg py-padding-md"
          style={{ scrollbarWidth: "none" }}
        >
          <CommonLayout>
            <div
              className="w-width-full max-h-auto rounded-border-radius-md"
              style={{ scrollbarWidth: "none" }}
            >
              {!isStepValid && (
                <>
                  <div className=" bg-emphasis flex mb-margin-md rounded-border-radius-md">
                    <div className=" flex p-padding-md  items-center justify-center">
                      <img
                        className="w-icon-md h-icon-md"
                        src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                        alt="Error icon"
                      />
                      <p className=" ml-margin-sm text-text-primary text-font-sm font-normal">
                        The transaction amount should not exceed the requested
                        amount.
                      </p>
                    </div>
                  </div>
                </>
              )}

              <Amount
                title={TEXT?.AMOUNT}
                onAmountExceedsRequested={(e) => {
                  CommonToast({
                    text: "Can not exceed requested amount.",
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  });
                }}
                amount={
                  type === "PayFieldForceTxn" &&
                  Number(currentAccountDetails?.requested_amount) ===
                    Number(txnPayLoad?.amount)
                    ? formattedAmount(currentAccountDetails?.requested_amount)
                    : txnPayLoad?.amount
                }
                amountInWords={
                  type === "PayFieldForceTxn" &&
                  currentAccountDetails?.requested_amount === txnPayLoad?.amount
                    ? RequestAmountWords(
                        currentAccountDetails?.requested_amount,
                      )
                    : amountInWords
                }
                copyData={copyData}
                onAmountChange={(val) =>
                  handleAmountChange({ name: "amount", value: val })
                }
                onPasteApplied={() =>
                  setCopyData({ title: "", data_type: "", value: "" })
                }
                isPreview={false}
                handleRadioBtn={handleRadioBtn}
                NewAmount={NewAmount}
                selectedRadioValue={selectedValueName}
                handleDivBtn={(val) => handleDivBtn(val)}
                customAmountRequired={
                  type === "PayFieldForceTxn" ? true : false
                }
                isAmountExceeding={isAmountExceeding}
              />

              <div className="bg-primary-card mt-margin-md rounded-border-radius-md p-padding-md">
                <div className="mb-margin-md flex flex-col gap-gap-xs">
                  <h1 className="font-semibold text-text-primary text-font-md">
                    Comment <span className="font-normal">(Optional)</span>
                  </h1>
                  <div className="text-font-xs text-text-secondary">
                    Enter a comment to provide additional context for this
                    transaction.
                  </div>
                </div>
                <TextInputField
                  placeholder="Comment"
                  name="comment"
                  fontKind="big"
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  value={txnPayLoad?.comment}
                  isFullWidth={true}
                  adornment=""
                  variant={computeCommentVariant(
                    txnPayLoad?.comment,
                    isCommentFocused,
                  )}
                  onFocus={() => setIsCommentFocused(true)}
                  onBlur={() => setIsCommentFocused(false)}
                  onInput={(e) => {
                    const value = e.target.value
                      .replace(/\s+/g, " ")
                      .replace(/^\s/, "")
                      .slice(
                        GlobalConfiguration.lengthCheckZero,
                        RejectReasonLength.lengthOfDecline,
                      );
                    setTxnPayLoad((prev) => ({
                      ...prev,
                      comment: value,
                    }));
                  }}
                />
                <div className="text-text-primary text-font-xs pt-padding-xs">
                  Note: Minimum 3 characters required.
                </div>
              </div>
            </div>
            <PaymentMethodSelector
              title={TEXT?.SELECT_PAYMENT_METHOD}
              slideAnimation={slideAnimation}
              previewMode={false}
              methods={[
                {
                  key: "neft",
                  label: TEXT?.NEFT,
                  subText: TEXT?.NEFT_TRANSFER_NOTE,
                  active: isNeft,
                  notes: [
                    TEXT?.TRANSACTION_EXECUTION_NOTE,
                    TEXT?.TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  // onClick: handleNeftClick,
                },
                {
                  key: "rtgs",
                  label: TEXT?.RTGS,
                  subText: TEXT?.INSTANT_TRANSFER_NOTE,
                  active: isRtgs,
                  notes: [
                    TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                    TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                    TEXT?.TRANSACTION_CHARGES_NOTE,
                  ],
                  // onClick: handleRtgsClick,
                },
              ]}
            />
          </CommonLayout>

          <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
        </div>
      )}
    </>
  );
};

export default FieldForceTransferAmount;
